import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";

export const deductRentForCustomer = async ({body, method, orderId}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.post(`${api.account}`, body, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {method},
        })
    } catch (error) {
        console.error("Error fetching book details:", error);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `/order/${orderId}`);

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await deductRentForCustomer({body, method, orderId});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}

export const transaction = async ({orderId, customerId, method, setCollectCashDisable}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.post(`${api.account}`, {
            orderId,
            customerId,
        }, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `${token}`,
            },
            params: {method},
        })
    } catch (error) {
        console.error("Error fetching book details:", error);
        setCollectCashDisable(false);
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await transaction({orderId, customerId, method, setCollectCashDisable});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}